<template>
  <div
    id="JobBorrowProductModal"
    class="modal fade"
    role="dialog"
    aria-labelledby="modelSingle"
    aria-hidden="true"
  >
    <div class="modal-dialog modal-xl" role="document">
      <!--begin::Form-->
      <form class="kt-form" @submit="formSubmit">
        <div class="modal-content">
          <div class="modal-header">
            <h5 class="modal-title">{{ this.$route.meta.breadcrumb }}</h5>
            <button
              type="button"
              class="close"
              data-dismiss="modal"
              aria-label="Close"
            ></button>
          </div>
          <div class="modal-body">
            <div class="kt-portlet__body">
              <div class="kt-section kt-section--first">
                <div class="row">
                  <div class="col-xl-12">
                    <div class="form-group">
                      <label class="label"
                        >ผู้ขอเบิกยืม: {{ jobsBorrowName }}</label
                      >
                    </div>
                  </div>
                </div>
                <div class="row">
                  <div class="col-xl-12">
                    <!-- Begin: table -->
                    <div class="col-sm-12 table-responsive">
                      <table
                        class="table table-sm table-striped table-bordered table-hover table-checkable"
                      >
                        <thead>
                          <tr>
                            <th
                              class="text-center align-middle"
                              width="5%"
                              rowspan="2"
                            >
                              ลำดับ
                            </th>
                            <th
                              class="text-center align-middle"
                              width="15%"
                              rowspan="2"
                            >
                              ร้านค้า/กิจกรรม<br />(หมายเหตุกิจกรรม)
                            </th>
                            <th
                              class="text-center align-middle"
                              width="10%"
                              rowspan="2"
                            >
                              มารับสินค้าเอง
                            </th>
                            <th
                              class="text-center align-middle"
                              width="20%"
                              style="width: 150px;"
                              rowspan="2"
                            >
                              รถขนส่ง
                            </th>
                            <th class="text-center" colspan="4">
                              รายการสินค้า
                            </th>
                          </tr>
                          <tr>
                            <th class="text-center">โควต้า(แบรนด์)</th>
                            <th class="text-center">สินค้า</th>
                            <th class="text-center">จำนวน</th>
                            <th class="text-center">หน่วย</th>
                          </tr>
                        </thead>
                        <tbody>
                          <template v-for="(item, i) in jobsBorrow">
                            <template v-if="item.items.length > 0">
                              <job-borrow-product-row
                                v-for="(prod, j) in item.items"
                                ref="jobsBorrowItem"
                                :key="prod.shopActivityId"
                                :rowIndex="i"
                                :itemIndex="j"
                                :showHeader="j == 0"
                                :rootItems="jobsBorrow"
                                :item="item"
                              ></job-borrow-product-row>
                            </template>
                            <template v-else>
                              <job-borrow-product-row
                                ref="jobsBorrowItem"
                                :key="item.id"
                                :rowIndex="i"
                                :itemIndex="0"
                                :rootItems="jobsBorrow"
                                :item="item"
                                :showHeader="true"
                              ></job-borrow-product-row>
                            </template>
                          </template>
                        </tbody>
                        <!-- <thead>
                          <tr>
                            <th class="text-center align-middle" width="5%">
                              ลำดับ
                            </th>
                            <th class="text-center align-middle" width="25%">
                              ร้านค้า/กิจกรรม
                            </th>
                            <th class="text-center align-middle" width="10%">
                              มารับสินค้าเอง
                            </th>
                            <th class="text-center align-middle" width="25%">
                              รถขนส่ง
                            </th>
                            <th class="text-center align-middle" colspan="4">
                              รายการสินค้า
                            </th>
                          </tr>
                          <tr>
                            <th class="text-center">โควต้า</th>
                            <th class="text-center">สินค้า</th>
                            <th class="text-center" width="15%">จำนวน</th>
                            <th class="text-center" width="15%">หน่วย</th>
                        </tr>
                        </thead>
                        <tbody>
                          <template v-for="(item, i) in jobsBorrow">
                            <template v-if="item.length > 0">
                              <job-borrow-product-row
                                v-for="(prod, j) in item"
                                ref="jobsBorrow"
                                :key="prod.shopActivityId"
                                :rowIndex="i"
                                :itemIndex="j"
                                :showHeader="j == 0"
                                :rootItems="jobsBorrow"
                                :item="item"
                              ></job-borrow-product-row>
                            </template>
                            <template v-else>
                              <job-borrow-product-row
                                ref="jobsBorrow"
                                :key="item.shopActivityId"
                                :rowIndex="i"
                                :itemIndex="0"
                                :showHeader="true"
                                :rootItems="jobsBorrow"
                                :item="item"
                              ></job-borrow-product-row>
                            </template>
                          </template>
                        </tbody> -->
                      </table>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="modal-footer">
            <button
              type="button"
              class="btn btn-secondary"
              data-dismiss="modal"
            >
              <i class="la la-close"></i> ปิดหน้าต่าง
            </button>
            <button type="submit" class="btn btn-primary">
              <i class="la la-save"></i> ยืนยัน
            </button>
          </div>
        </div>
      </form>
      <!--end::Form-->
    </div>
  </div>
</template>

<script>
import Vue from "vue";
import axios from "axios";
import select2 from "../../Shared/Select2";
import JobBorrowProductRow from "./JobBorrowProductRow";

require("datatables.net-autofill-bs4");
require("datatables.net-bs4");
require("datatables.net-buttons-bs4");
require("datatables.net-colreorder-bs4");
require("datatables.net-fixedcolumns-bs4");
require("datatables.net-fixedheader-bs4");
require("datatables.net-keytable-bs4");
require("datatables.net-responsive-bs4");
require("datatables.net-rowgroup-bs4");
require("datatables.net-rowreorder-bs4");
require("datatables.net-scroller-bs4");
require("datatables.net-select-bs4");
require("sweetalert2");

export default {
  components: {
    JobBorrowProductRow,
    select2,
  },
  data: function() {
    var self = this;
    return {
      qty: null,
      tpbPlantId: null,
      tpbProductId: null,
      jobsBorrow: [],
      jobsBorrowName: null,
      itemjobBTransit: null,
      jobBTransitOptions: {
        placeholder: "กรุณาเลือก",
        allowClear: false,
        ajax: {
          url: "/Api/Transport/Select2Transport",
          type: "post",
          delay: 300,
          dataType: "json",
          contentType: "application/json",
          data: function(params) {
            var query = {
              search: params.term,
              page: params.page || 1,
              showVendorTransport: false,
              agentCodes: [],
            };

            return JSON.stringify(query);
          },

          processResults: function(data, params) {
            return {
              results: data.results,
              pagination: {
                more: data.more,
              },
            };
          },
          transport: function(params, success, failure) {
            params.beforeSend = function(request) {
              request.setRequestHeader(
                "Authorization",
                "Bearer " + self.$root.user.access_token
              );
            };
            var $request = $.ajax(params);
            $request.then(success);
            $request.fail(failure);
            return $request;
          },
        },
      },
    };
  },
  methods: {
    formSubmit: function(e) {
      e.preventDefault();
      let router = this.$router;
      let self = this;

      if (
        !$("#JobBorrowProductModal form")
          .validate()
          .form()
      ) {
        return false;
      }

      KTApp.blockPage({
        opacity: 0.05,
        message: "กำลังบันทึกข้อมูล กรุณารอสักครู่...",
      });

      var jItems = [];

      self.jobsBorrow.forEach((element) => {
        var pItems = [];
        element.items.forEach((p) => {
          pItems.push({
            MaterialCode: p.materialCode,
            Qty: p.qty,
            QuotaId: p.quotaId,
            BorrowQuantity: p.borrowQuantity,
          });
        });

        jItems.push({
          ProductLoanHeaderId: element.productLoanHeaderId,
          BorrowerId: element.borrowerId,
          BorrowerIsAgent: element.borrowerIsAgent,
          IsPickUp: element.isPickUp,
          AgentCode: element.agentCode,
          TransitId: element.TransitId,
          RequestDate: element.requestDate,
          NextShopCode: element.isAgent ? element.shopActivityId : null,
          ActivityId: element.isActivity ? element.shopActivityId : null,
          ActivityRemark: element.activityRemark,
          Items: pItems,
        });
      });

      axios({
        method: "post",
        url: "/Api/ProductLoan/OpenJob",
        data: {
          Obj: jItems,
        },
      })
        .then(function(response) {
          if (response.data.status) {
            Swal.fire("สำเร็จ", response.data.message, "success").then(
              function() {
                $("#JobBorrowProductModal").modal("hide");
              }
            );
          } else {
            Swal.fire(
              "เกิดข้อผิดพลาด",
              error.response.data.message,
              "error"
            ).then(function() {
              $("#JobBorrowProductModal").modal("hide");
            });
          }
        })
        .catch(function(error) {
          Swal.fire(
            "เกิดข้อผิดพลาด",
            error.response.data.message,
            "error"
          ).then(function() {
            $("#JobBorrowProductModal").modal("hide");
          });
        })
        .then(function() {
          // always executed
          KTApp.unblockPage();
        });
    },
  },
  async mounted() {
    let self = this;
    let router = this.$router;
    let user = await this.$root.getUser();

    // set validation rules
    $("#JobBorrowProductModal form").validate({
      rules: {
        tpbPlantId: "required",
        tpbProductId: "required",
        qty: "required",
      },
      messages: {
        tpbPlantId: "กรุณาเลือกชื่อเจ้าของทรัพย์สิน",
        tpbProductId: "กรุณาเลือกสินค้า",
        qty: "กรุณาระบุจำนวน",
      },
    });

    $("#JobBorrowProductModal").on("hidden.bs.modal", function() {
      // Set go back
      router.go(-1);
      self.$parent.reloadDataTable(false);
    });

    axios
      .get("/Api/ProductLoan/GetJob/" + this.$route.params.id)
      .then(function(response) {
        if (response.status == 200) {
          if (response.data != null && response.data.length > 0) {
            self.jobsBorrow = response.data;
            self.jobsBorrowName = response.data[0].borrowerName;
          }
          $("#JobBorrowProductModal").modal("show");
        } else {
          Swal.fire(
            "เกิดข้อผิดพลาด",
            "ไม่พบข้อมูลการสั่งซื้อที่คุณเลือก",
            "warning"
          );
          //router.go(-1);
        }
      })
      .catch(function(error) {
        Swal.fire(
          "เกิดข้อผิดพลาด",
          "ระบบเกิดข้อผิดพลาด ไม่สามารถดึงข้อมูลการสั่งซื้อได้ในขณะนี้",
          "error"
        );
        //router.go(-1);
      })
      .then(function() {
        // always executed

        KTApp.unblockPage();
      });
  },
};
</script>

<style lang="scss" scoped></style>



// WEBPACK FOOTER //
// App/Components/Borrow/JobBorrowProduct.vue